import {
  AWARD_EVENT_DETAILS_ACTION_TYPE,
  AWARD_LIST_ACTION_TYPE,
  IU_AWARD_EVENT_MILESTONE_ACTION_TYPE,
  DELETE_AWARD_EVENT_ACTION_TYPE,
  INSERT_MILESTONE_MASTER_ACTION_TYPE,
  IU_AWARD_PROFILE_ACTION_TYPE,
  AWARD_PROFILE_DETAILS_ACTION_TYPE,
  IU_AWARD_PROFILE_MILESTONE_ACTION_TYPE,
  IU_AWARD_PROFILE_APPLICATION_SECTION_ACTION_TYPE,
  IU_AWARD_PROFILE_SCORING_PATTERN_ACTION_TYPE,
  IU_AWARD_EVENT_JURY_ACTION_TYPE,
  DELETE_AWARD_PROFILE_ACTION_TYPE,
  IU_AWARD_PROFILE_APPLICATION_FEE_ACTION_TYPE,
  AWARD_PROFILE_CHANGE_SEQ_ACTION_TYPE,
} from "../../utils/constants";

const initialState = [];
function awardEventReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case INSERT_MILESTONE_MASTER_ACTION_TYPE:
      return [...state, payload];
    case AWARD_LIST_ACTION_TYPE:
      return [...state, payload];
    case AWARD_EVENT_DETAILS_ACTION_TYPE:
      return [...state, payload];
    case IU_AWARD_EVENT_MILESTONE_ACTION_TYPE:
      return [...state, payload];
    case IU_AWARD_EVENT_JURY_ACTION_TYPE:
      return [...state, payload];
    case DELETE_AWARD_EVENT_ACTION_TYPE:
      return [...state, payload];
    //profile
    case AWARD_PROFILE_DETAILS_ACTION_TYPE:
      return [...state, payload];
    case IU_AWARD_PROFILE_ACTION_TYPE:
      return [...state, payload];
    case IU_AWARD_PROFILE_APPLICATION_SECTION_ACTION_TYPE:
      return [...state, payload];
    case IU_AWARD_PROFILE_SCORING_PATTERN_ACTION_TYPE:
      return [...state, payload];
    case IU_AWARD_PROFILE_MILESTONE_ACTION_TYPE:
      return [...state, payload];
    case IU_AWARD_PROFILE_APPLICATION_FEE_ACTION_TYPE:
      return [...state, payload];
    case DELETE_AWARD_PROFILE_ACTION_TYPE:
      return [...state, payload];
    case AWARD_PROFILE_CHANGE_SEQ_ACTION_TYPE:
      return [...state, payload];
    default:
      return state;
  }
}
export default awardEventReducer;
